import { Injectable, Type } from '@angular/core';

import { Product } from '@shared/models/products.model';
import { CommandAvailabilityService } from '@shared/services/command-availability.service';

import { BaseRestrictionCommand } from './base-restriction.command';
import { HideAccountInlineComponent } from './components/hide-account-inline/hide-account-inline.component';
import { RestrictionCommandResult } from './restriction-command.interface';

@Injectable({ providedIn: 'root' })
export class HideAccountCommand extends BaseRestrictionCommand {
  public readonly icon = 'eye-open';
  public readonly isDangerous = false;
  public readonly settingsNames = undefined;
  public readonly title = 'Скрыть счет';
  public readonly type = 'hideAccount';
  public readonly group = 'visibility';
  public readonly order = 1;
  public readonly isInline = true;
  public readonly inlineComponent: Type<HideAccountInlineComponent> = HideAccountInlineComponent;

  constructor(commandAvailabilityService?: CommandAvailabilityService) {
    super(commandAvailabilityService);
  }

  public async execute(_context: { data: Product }): Promise<RestrictionCommandResult> {
    // Для inline компонентов execute не вызывается
    // Логика реализована в самом компоненте

    return { success: false, shouldCloseParent: false };
  }
}
